// extracted by mini-css-extract-plugin
export var infoItem = "_to-2";
export var title = "_to-0";
export var value = "_to-1";